const ERROR_CODE = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BACKGROUND_MUSIC_INVALID: 'BACKGROUND_MUSIC_INVALID',

  USER_NOT_FOUND: 1001,
  TEXT_TOO_LONG: 1002,
  USER_EXISTS: 1003,
  USER_NOT_ACTIVATED: 1004,
  INVALID_SYNTAX: 1006,
  FEATURE_NOT_IN_PACKAGE: 1012,
  SPAM_ACCOUNT: 1034,
  INACTIVE_VOICE: 1036,
  NO_MORE_SUPPORT_VOICE: 1037,
  LIMIT_FREE_INSTANT_VOICE_SYNTHESIS: 1038,
  SPEAKER_LIMIT_EXCEEDED: 1046,
  EXCEED_MAX_TOTAL_CHARACTERS: 1050,

  // Voice cloning
  DISCARDED_VOICE_CLONING: 5003,

  PAYMENT_HUB_ERROR: 2001,
  PENDING_ORDER: 2002,
  ADMIN_ORDER: 2004,

  USED_VOUCHER: 3003,
  INVALID_VOUCHER: 3004,
  OUT_OF_VOUCHERS: 3005,

  NO_ENOUGH_CONDITION_SUBMIT: 4005,
  VOICE_USERNAME_INVALID: 4006,

  // Rate limit
  EXCEED_RATE_LIMIT: 8000,

  // Voice preset
  VOICE_PRESET_EXISTED: 1043,
  VOICE_TRIAL_LIMIT_REACHED: 1045,

  VOICE_NAME_EXISTS: 4028,
  VOICE_NAME_INVALID: 4029,
  SPEAKER_NAME_EXISTED: 1049,
  BLOCK_PACKAGE_PURCHASE: 6001,

  // verification voice
  VOICE_ALREADY_VERIFIED: 8003,
  PROJECT_NOT_FOUND: 1040,
  CAPTION_FONT_NOT_FOUND: 1058,
};

export { ERROR_CODE };
